import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { Pill } from "PFComponents/pill";
import { Color } from "PFCore/types";

type ImportStatePillProps = {
  text: string;
  backgroundColor?: Color;
  textColor?: Color;
};

export const ImportStatePill = ({ text, backgroundColor, textColor }: ImportStatePillProps) => {
  const { themeVars } = useTheme();

  return (
    <Pill
      text={text}
      style={{
        ...(backgroundColor ? { backgroundColor: themeVars[backgroundColor] } : {}),
        ...(textColor ? { color: themeVars[textColor] } : {})
      }}
      small
    />
  );
};
